import {Component, Input, OnInit} from '@angular/core';
import {ModalController} from '@ionic/angular';
import {AddcustomerPage} from '../addcustomer/addcustomer.page';
import {CustomerModel} from '../../models/customer.model';
import {LokijsService} from '../../services/database/lokijs.service';
import {RefreshdatabaseService} from '../../services/database/refreshdatabase.service';
import {TestConnectionService} from '../../services/test-connection.service';
import {GeneralService} from '../../services/general.service';
import {DocumentModel} from '../../models/document.model';
import { StateManagerService } from 'src/app/services/state-manager.service';
import { CollectionsNames } from 'src/app/definitions/collections-names';

@Component({
    selector: 'app-searchcustomer',
    templateUrl: './searchcustomer.page.html',
    styleUrls: ['./searchcustomer.page.scss'],
})
export class SearchcustomerPage implements OnInit {
    @Input() document: DocumentModel;
    customerList: CustomerModel[];
    depots: any[];
    queryText = '';

    constructor(public modalController: ModalController,
                private loki: LokijsService,
                private refreshDB: RefreshdatabaseService,
                private testConnection: TestConnectionService,
                private generalService: GeneralService,
                private stateManager: StateManagerService,
                private collectionNames: CollectionsNames) {
    }

    async ngOnInit() {
        this.populateCustomerList();
        this.populateDepotList();
    }

    populateCustomerList() {
        this.customerList = this.loki.getCollection('customer').chain().simplesort('name').data();
    }

    populateDepotList(){
        this.depots = this.stateManager.getCollection(this.collectionNames.DEPOT);
    }
    async openModalAddCustomer() {
        const modalAdd = await this.modalController.create({
            component: AddcustomerPage,
            cssClass: 'modal-fullscreen',
            componentProps: {}
        });

        modalAdd.onDidDismiss().then((dataReturned) => {
            if (dataReturned.data) {
                this.modalController.dismiss(dataReturned.data);
            }
        });
        return await modalAdd.present();
    }

    async fetchCustomers(event) {
        this.testConnection.pingServer().then(res => {
            this.refreshDB.refreshCustomerResource().then(() => {
                this.populateCustomerList();
                event.target.complete();
            });
        }).catch(err => {
            this.generalService.createToast('No connection to the server');
            event.target.complete();
        });
    }

    selectCustomer(cust: CustomerModel) {
        if (cust.suspended === 'Y' && this.document) {
            this.generalService.createToast('This customer is supended');
        } else {
            this.modalController.dismiss(cust);
        }
    }

    getDepotName( cod : number ){
        var depotName = 'Unknown';
        const xname = this.depots.filter( depot => {
            return depot.cod === cod;
        });

        if(xname.length === 1){
            depotName = xname[0].descr;
        }
        return depotName;
    }
}
